module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Folder-7b8ab7cc1516c728b83e2ffb5450f576.svg";